import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum WeightScaleEnum {
    Lbs = 1 as any,
    Kg = 2 as any
}
class WeightScaleClass extends EnumWithDescription<WeightScaleEnum> {
    public readonly enum = WeightScaleEnum;
    public readonly enumName: string = "WeightScaleEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<WeightScaleEnum>> = new Map([
        [
            "Lbs",
            {
                value: WeightScaleEnum.Lbs,
                name: "Lbs"
            }
        ],
        [
            "Kg",
            {
                value: WeightScaleEnum.Kg,
                name: "Kg"
            }
        ]
    ]);
}

export const WeightScale = new WeightScaleClass();
